import React from 'react';
import classnames from 'classnames';
import castArray from 'lodash/castArray';

const TalwindcssBlock = ({
  useDivTag,
  children,
  className,
  style,
  hover = [],
  focus = [],
  ...classNames
}) => {
  const props = React.useMemo(
    () => ({
      className: classnames(
        className,
        classNames,
        castArray(hover).map(hoverClassName => `hover:${hoverClassName}`),
        castArray(focus).map(focusClassName => `focus:${focusClassName}`),
      ),
      style,
    }),
    [className, classNames, focus, hover, style],
  );

  if (useDivTag) {
    return React.createElement('div', props, children);
  }

  return React.cloneElement(children, props);
};

export default React.memo(TalwindcssBlock);
